// extracted by mini-css-extract-plugin
export default {"divcont":"taskmanager_divcont__pUShu","droper":"taskmanager_droper__p2Eb4","floatingbutton":"taskmanager_floatingbutton__RAjJY","attachBox":"taskmanager_attachBox__N7vyD"};